export const INIT_NEW_PROJECT = 'INIT_NEW_PROJECT';

export function initNewProject(){
    return{
        type: INIT_NEW_PROJECT
    }
}